import { Contact } from './contact';
import { ActiveStates } from './enums/active-states';
import { DialerTypes } from './enums/dialer-types';
import { ExtensionTypes } from './enums/extension-types';
import { RegistrationStates } from './enums/registration-states';
import { IExtension } from './interfaces/extension.interface';

export class Extension {
    public id: string;
    public enabled: boolean;
    public createdAt: Date;
    public updatedAt: Date;
    public deletedAt: Date;
    public appData: string = '';
    public organizationId: string;
    public ownerId: string;
    public applicationId: string;
    public type: ExtensionTypes = ExtensionTypes.user;
    public userId: string;
    public siteId: string = '';
    public number: string;
    public name: string;
    public account: string;
    public password: string;
    public realm: string;
    public registrationState: RegistrationStates = RegistrationStates.undefined;
    public registrationDatetime: Date;
    public activeState: ActiveStates = ActiveStates.none;
    public activeDatetime: Date;
    public allowedNetwork: string = '';
    public extensions: string[] = [];
    public dialerType: DialerTypes = DialerTypes.none;
    public externalNumber: string = '';
    public service: string = '';
    public calendarId: string = '';
    public privacy: boolean;
    public allowInbound: boolean = true;
    public allowOutbound: boolean = true;
    public features: Object;
    public contacts: Contact[] = [];

    // Propriétés utilisées pour le web
    public isSelected: boolean = false;

    public static create(extension: IExtension): Extension {
        let keys = Object.keys(extension);
        let newInstance = new Extension();
        keys.forEach((key) => {
            newInstance[key] = extension[key];
        });

        return newInstance;
    }

    public static createArray(extensions: IExtension[]): Extension[] {
        let instances: Extension[] = [];

        extensions.forEach((extension) => {
            instances.push(Extension.create(extension));
        });

        return instances;
    }
}
